import { useUpcomingBooking } from '@web/pages/v5/home/UpcomingSection/hooks/useUpcomingBooking'
import { useUpcomingOrder } from '@web/pages/v5/home/UpcomingSection/hooks/useUpcomingOrder'
import { useUpcomingTrainTicket } from '@web/pages/v5/home/UpcomingSection/hooks/useUpcomingTrainTicket'
interface Props {
  limit?: number
}

export const useUpcomingTotal = ({ limit }: Props = { limit: 10 }) => {
  const { upcomingBookingItems, upcomingBookingCount, resetUpcomingBooking } = useUpcomingBooking({ limit })
  const { upcomingOrderItems, upcomingOrderCount, resetUpcomingOrder } = useUpcomingOrder({ limit })
  const { upcomingTrainTicketItems, upcomingTrainTicketCount, resetUpcomingTrainTicket } = useUpcomingTrainTicket({
    limit,
  })

  const upcomingTotalItems = [...upcomingOrderItems, ...upcomingTrainTicketItems, ...upcomingBookingItems]

  const resetUpcomingAll = () => {
    resetUpcomingBooking()
    resetUpcomingOrder()
    resetUpcomingTrainTicket()
  }

  return {
    upcomingTotalItems,
    upcomingTotalCount: upcomingBookingCount + upcomingOrderCount + upcomingTrainTicketCount,
    upcomingBookingItems,
    upcomingOrderItems,
    upcomingTrainTicketItems,
    upcomingBookingCount,
    upcomingOrderCount,
    upcomingTrainTicketCount,
    resetUpcomingAll,
  }
}
